import db, { parseFirestoreDoc } from '@helpers/firebase/Firestore';
import { User, UserPrivate } from '@types';

export function parseUserDoc(doc: db.DocumentSnapshot) {
  return parseFirestoreDoc<User>(doc, 'userId');
}

export function parseUserPrivateDoc(doc: db.DocumentSnapshot) {
  return parseFirestoreDoc<UserPrivate>(doc, 'userId');
}
